import React from "react";
import themeLarge from "../ThemeLarge";

class ProjectUrlView extends React.Component {
  constructor(props) {
    super(props);
    this.title = this.props.title;
    this.url = this.props.url;
    this.state = {
      isHovered: false,
    };
  }

  handleMouseEnter = () => {
    this.setState({ isHovered: true });
  };

  handleMouseLeave = () => {
    this.setState({ isHovered: false });
  };

  render() {
    const { isHovered } = this.state;

    const containerStyle = {
      fontSize: themeLarge.fontSize.h4,
      width: "100%",
      color: isHovered ? "#fff" : "#000",
      backgroundColor: isHovered ? themeLarge.colors.text : "transparent",
      borderRadius: "15px",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: isHovered ? "transparent" : themeLarge.colors.hover,
      marginBottom: "15px",
      marginTop: "15px",
      boxShadow: themeLarge.shadows.little,
      transform: isHovered ? "translateY(-5px)" : "translateY(0)",
      transition: "all 0.3s ease-in-out",
      padding: "10px 20px",
      textAlign: "center",
    };

    const linkStyle = {
      color: isHovered ? "#fff" : "#000",
      textDecoration: "none",
    };

    return (
      <div
        className="d-flex justify-content-center"
        style={containerStyle}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onClick={() => window.open(this.url, "_blank", "noopener,noreferrer")}
      >
        <a href={this.url} target="_blank" rel="noreferrer" style={linkStyle}>
          {this.title}
        </a>
      </div>
    );
  }
}

export default ProjectUrlView;
